import React from 'react'
import Section from '../Section'
import PricingTable from 'features/PricingTable'
import Markdown from 'features/Markdown'
import s from './PricingTable.scss'
import sLay from 'styles/modules/layout.scss'
import cn from 'classnames'
import { get } from 'lodash'

export const Toggle = ({ text1, text2, active, replace, location, queryParam }) => (
  <div
    className={cn(s.toggleOuter, sLay['layout-row'], sLay['layout-align-center-center'])}
    onClick={() =>
      replace({
        pathname: location.pathname,
        query: {
          ...location.query,
          [queryParam]: active ? text1 : text2,
        },
      })
    }
  >
    <div className={!active ? s.activeText : ''}>{text1}</div>
    <div className={s.toggle}>
      <div className={cn(s.toggleSwitch, { [s.active]: active })} />
    </div>
    <div className={active ? s.activeText : ''}>{text2}</div>
  </div>
)

export default props => {
  const isActive =
    props.toggleQueryParam &&
    get(props, ['location', 'query', props.toggleQueryParam]) === props.toggleText2
  return (
    <Section
      color={props.color}
      sectionWidth={props.sectionWidth}
      fullHeight={props.fullHeight}
      paddingTop={props.paddingTop}
      paddingBottom={props.paddingBottom}
    >
      {props.toggleText1 && props.toggleText2 && props.toggleQueryParam && (
        <div className={cn(sLay['layout-column'], sLay['layout-center-center'])}>
          <Toggle
            text1={props.toggleText1}
            text2={props.toggleText2}
            active={isActive}
            location={props.location}
            queryParam={props.toggleQueryParam}
            replace={props.replace}
          />
        </div>
      )}
      {!isActive
        ? [
            <Markdown
              key="text1"
              text={props.text}
              color={props.color}
              style={{ maxWidth: '700px', margin: '0 auto 30px', textAlign: 'center' }}
            />,
            <PricingTable key="table1" details={props.details} location={props.location} />,
          ]
        : [
            <Markdown
              key="text2"
              text={props.text2}
              color={props.color}
              style={{ maxWidth: '700px', margin: '0 auto 30px', textAlign: 'center' }}
            />,
            <PricingTable key="table2" details={props.details2} location={props.location} />,
          ]}
    </Section>
  )
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Cms/Sections/PricingTable/PricingTable.jsx